<template>
    <div v-if="select_items_existing_coureurs.length > 1">
        <div>
            <v-icon icon="mdi-arrow-down"></v-icon>
            <b>Mes participants</b>: Retrouver un participant déjà associé à {{ account_wording[0] }} ({{
                get_nb_coureurs_existants
            }})
        </div>
        <div class="container_select_existing">
            <v-select return-object @update:modelValue="select_existing_coureur" v-model="selected"
                :items="select_items_existing_coureurs"></v-select>
        </div>
    </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import { useAuthUserStore } from "@/stores/authUserStore";
export default {
    props: ['coureur'],
    name: 'SelectCoureurFromAccount',
    data() {
        return {
            selected: { title: "Nouveau participant", value: "" },
        };
    },
    watch: {
        'coureur.id': function (val) {
            if (!val) {
                this.selected = { title: "Nouveau participant", value: "" };
            }
        },
        'authUserStore.isLogged': async function () {
            await this.authUserStore.fetch_coureurs();
            this.selected = { title: "Nouveau participant", value: "" };
        }
    },
    computed: {
        ...mapStores(useAuthUserStore, useMainStore),
        account_wording() {
            const is_bicentenaire = this.mainStore.module.is_BICENTENAIRE26_module;
            if (is_bicentenaire) {
                return ["mon espace personnel", "espace personnel"];
            } else {
                return ["mon compte", "compte"];
            }
        },
        select_items_existing_coureurs() {
            if (!this.authUserStore.list_coureurs) {
                return [{ value: "", title: "Nouveau participant" }];
            }
            let coureurs = JSON.parse(JSON.stringify(this.authUserStore.list_coureurs.list));
            let existing = coureurs.map((item) => {
                let coureur = {};
                coureur.value = item.id;
                coureur.title = item.nom_coureur;
                return coureur;
            });
            existing.unshift({ value: "", title: "Nouveau participant" });
            return existing;
        },
        get_nb_coureurs_existants() {
            const count_coureurs = this.select_items_existing_coureurs.length - 1;
            let response = "";
            response += count_coureurs;
            if (count_coureurs > 1) {
                response += " coureurs existants";
            } else {
                response += " coureur existant";
            }
            return response;
        },
        // Your computed properties go here
    },
    methods: {
        select_existing_coureur(s) {
            const selection = parseInt(s.value);
            if (selection == 0) {
                this.$emit('onClearCoureur');
            } else {
                let c = this.authUserStore.list_coureurs.list.find((item) => item.id == selection);
                this.$emit('onSelectCoureur', c);
            }
        },
    },
    async mounted() {
        if (!this.authUserStore.has_coureurs) {
            await this.authUserStore.fetch_coureurs();
        }
        if (this.coureur && this.coureur.id) {
            this.selected = { title: this.coureur.nom_coureur, value: this.coureur.id };
        }
    }
};
</script>

<style scoped>
.container_select_existing {
    width: 500px;
    max-width: 100%;
}

/* Your component styles go here */
</style>